import { Component } from '@angular/core';

@Component({
    selector: 'app-facebook-banner',
    templateUrl: './facebook-banner.component.html',
    styleUrl: './facebook-banner.component.scss',
    standalone: false
})
export class FacebookBannerComponent {

}
